import { render, staticRenderFns } from "./footer-vip.vue?vue&type=template&id=2d1784c6&"
import script from "./footer-vip.vue?vue&type=script&lang=js&"
export * from "./footer-vip.vue?vue&type=script&lang=js&"
import style0 from "./footer-vip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports